import { render, staticRenderFns } from "./CourseVideoDetails.vue?vue&type=template&id=7d74e070"
import script from "./CourseVideoDetails.vue?vue&type=script&lang=js"
export * from "./CourseVideoDetails.vue?vue&type=script&lang=js"
import style0 from "./CourseVideoDetails.vue?vue&type=style&index=0&id=7d74e070&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports